import { Stack, CircularProgress, Typography } from "@mui/material";

import App from "../../App/App";
import { useAuth } from "../../contexts/auth-context";
import LoginPage from "../LoginPage/LoginPage";

// Full page loader component
function FullPageLoader() {
  return (
    <Stack direction="column" minHeight="100vh" alignItems="center" justifyContent="center" bgcolor="#F0F3F5">
      <CircularProgress size={48} />
      <Typography mt={2} variant="body1" color="text.secondary">
        Loading...
      </Typography>
    </Stack>
  );
}

function Authenticator() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <FullPageLoader />;
  }

  return isAuthenticated ? <App /> : <LoginPage />;
}

export default Authenticator;
